import type { ReactNode } from 'react';

/**
 * A message the user needs to notice.
 *
 * Errors use `role="alert"` so assistive technology announces them immediately;
 * quieter messages use a polite live region so they do not interrupt.
 *
 * `warning` is distinct from `error` on purpose. A degraded platform connection
 * that Connaro is already retrying is not a failure the operator must act on,
 * and presenting it as one during a live broadcast trains them to ignore real
 * errors.
 */
export function Alert({
  tone,
  children,
}: {
  tone: 'error' | 'warning' | 'success' | 'info';
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div
      className={`alert alert--${tone}`}
      role={tone === 'error' ? 'alert' : 'status'}
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
    >
      {children}
    </div>
  );
}
